import { useParams } from 'react-router-dom';
import { MyParams, RouteEnum, generateRoutePath } from 'App/routes';
import { NestedRouteComponent, usePartner } from '@shared';
import { List, Create } from './components';
import { Edit } from './components/edit';

export const Exams = () => {
  const { partner, course } = useParams<keyof MyParams>() as MyParams;
  const { enableSelfService } = usePartner({ partner });
  const rootPath = generateRoutePath({
    name: RouteEnum.Exams,
    params: { partner, course },
  });

  const ListComponent = <List rootPath={rootPath} partner={partner} course={course} />;
  const CreateComponent = <Create rootPath={rootPath} partner={partner} course={course} />;
  const EditComponent = <Edit rootPath={rootPath} partner={partner} course={course} />;

  return (
    <>
      <NestedRouteComponent
        canCreate={enableSelfService}
        canEdit={enableSelfService}
        rootPath={rootPath}
        List={ListComponent}
        Create={CreateComponent}
        Edit={EditComponent}
      />
    </>
  );
};
